<template>
  <main class="medcard-merging">
    <h1>Объединение медицинских карт пациентов</h1>
    <form
      v-if="hasMerging"
      class="medcard-merging__form"
      v-on:submit.prevent="onMergingSubmit"
    >
      <div class="medcard-merging__wrapper-description">
        <p
          class="medcard-merging__description"
          v-bind:key="`merging-descriptions:${index}`"
          v-for="(text, index) in $options.mergingDescriptions"
        >{{ text }}</p>
      </div>
      <div class="medcard-merging__wrapper-table">
        <table class="medcard-merging-cards">
          <thead class="medcard-merging-cards__head-line">
            <tr>
              <th
                class="medcard-merging-cards__head-cell"
                v-bind:key="`merging-cards:columns:${columnIndex}`"
                v-for="(title, columnIndex) in mergingColumns"
              >{{ title }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="medcard-merging-cards__body-line"
              v-bind:key="`merging-cards:rows:${rowIndex}`"
              v-for="({
                cells,
                links,
                options,
                value,
              }, rowIndex) in mergingRows"
            >
              <td
                class="medcard-merging-cards__body-cell"
                :class="{ 'body-cell-link': cellIndex === 0 }"
                v-bind:key="`merging-cards:rows:${rowIndex}:title-cells:${cellIndex}`"
                v-for="(title, cellIndex) in cells"
              >
                <template v-if="cellIndex === 0">
                  <template v-for="({ identity, to }, linkIndex) in links">
                    <router-link
                      target="_blank"
                      v-bind:key="`merging-cards:rows:${rowIndex}:links:${linkIndex}`"
                      v-bind:to="{
                        name: 'ClinicPanelPatientBasic',
                        params: { id: identity },
                      }"
                      v-if="to === 'patient-card'"
                    >{{ title }}</router-link>
                  </template>
                </template>
                <template v-else>{{ title }}</template>
              </td>
              <td
                class="medcard-merging-cards__body-cell"
                v-bind:key="`merging-cards:rows:${rowIndex}:option-cells:${cellIndex}`"
                v-for="({ name, title }, cellIndex) in options"
              >
                <label class="medcard-merging-option">
                  <input
                    required
                    type="radio"
                    v-bind:name="name"
                    v-bind:value="value" />
                  {{ title }}
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="medcard-merging__wrapper-button">
        <button
          class="medcard-merging__cancel"
          type="button"
          v-on:click="onMergingCancel"
        >Отменить</button>
        <button
          class="medcard-merging__submit"
          type="submit"
        >Объединить</button>
      </div>
    </form>
    <template v-else>
      <form
        class="medcard-merging-search"
        v-on:submit.prevent="onSearchSubmit"
      >
        <autocomplete-input
          attach
          clearable
          hide-details
          disable-search
          class="medcard-merging-search__input"
          item-text="title"
          item-value="value"
          label="Пациенты"
          placeholder="Введите ФИО или телефон пациента"
          required="required"
          v-bind:items="patientOptions"
          v-bind:violations="[]"
          v-bind:search-input.sync="patientSearchQuery"
          v-model="patient"
          v-on:input="onInputPatient"
          v-on:search-input="onInputSearch"
        />
        <button
          class="medcard-merging-search__submit"
          type="submit"
        >Найти дубли</button>
      </form>
      <em v-if="isDuplicationFetching">Выполняется поиск дублей карт...</em>
      <strong v-else-if="duplicationFetchingDescription">
        {{ duplicationFetchingDescription }}
      </strong>
      <template v-else-if="hasDuplication">
        <div class="medcard-merging__wrapper-table">
          <table class="medcard-duplications">
            <thead class="medcard-duplications__head-line">
              <tr>
                <th
                  class="medcard-duplications__head-cell"
                  v-bind:key="`duplications:columns:${columnIndex}`"
                  v-for="(title, columnIndex) in duplicationColumns"
                >{{ title }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="medcard-duplications__body-line"
                v-bind:key="`duplications:rows:${rowIndex}`"
                v-for="({ cells, links, value }, rowIndex) in duplicationRows"
              >
                <td
                  class="medcard-duplications__body-cell"
                  :class="{ 'body-cell-link': cellIndex === 0 }"
                  v-bind:key="`duplications:rows:${rowIndex}:cells:${cellIndex}`"
                  v-for="(title, cellIndex) in cells"
                >
                  <template v-if="cellIndex === 0">
                    <input-checkbox
                      v-bind:value="duplicationPatientToChecked[value]"
                      v-on:input="onDuplicationPatientInput(value, $event)" />
                    <template v-for="({ identity, to }, linkIndex) in links">
                      <router-link
                        target="_blank"
                        v-bind:key="`duplications:rows:${rowIndex}:links:${linkIndex}`"
                        v-bind:to="{
                          name: 'ClinicPanelPatientBasic',
                          params: { id: identity },
                        }"
                        v-if="to === 'patient-card'"
                      >{{ title }}</router-link>
                    </template>
                  </template>
                  <template v-else>{{ title }}</template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button
          class="medcard-merging__submit"
          type="button"
          v-bind:disabled="hasNotEnoughSelectedPatients"
          v-on:click="onDuplicationSubmit"
        >Объединить</button>
      </template>
    </template>
    <modal-dialog
      content-class="medcard-merging-leave"
      title="Отменить объединение карт?"
      v-model="isShownDialogLeaveConfirm"
    >
      <div class="medcard-merging-leave__button-wrapper">
        <button
          class="medcard-merging-leave__no"
          type="button"
          v-on:click="isShownDialogLeaveConfirm = false"
        >Нет</button>
        <button
          class="medcard-merging-leave__yes"
          type="button"
          v-on:click="leaveWithoutSave"
        >Да, отменить</button>
      </div>
    </modal-dialog>
  </main>
</template>
<script>
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import InputCheckbox from '@/components/InputCheckbox.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import formMixin from '@/mixins/formMixin';
import notifierMixin from '@/mixins/notifierMixin';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import debounce from 'lodash.debounce';

/**
 * @description Раздел объединения карт.
 */
export default {
  components: {
    AutocompleteInput,
    InputCheckbox,
    ModalDialog,
  },
  computed: {
    /**
     * @description Пояснение к получению дублей.
     */
    duplicationFetchingDescription() {
      if (this.duplicationColumns.length === 0) {
        if (this.patient === null) {
          return 'Выберите пациента для поиска дублей';
        }
        if (this.duplicationFailTitle !== '') {
          return this.duplicationFailTitle;
        }
      }
      return '';
    },
    /**
     * @description Отображение пациента дубля на выбор к объединению.
     */
    duplicationPatientToChecked() {
      const pairs = this.duplicationRows.map(({ value }) => [
        value,
        this.selectedPatients.includes(value),
      ]);
      return Object.fromEntries(pairs);
    },
    /**
     * @description Имеются дубликаты.
     */
    hasDuplication() {
      return this.duplicationRows.length !== 0;
    },
    /**
     * @description Имеет объединение.
     */
    hasMerging() {
      return this.mergingRows.length !== 0;
    },
    /**
     * @description Имеет недостаточно выбранных пациентов на объединение.
     */
    hasNotEnoughSelectedPatients() {
      return this.selectedPatients.length < 2;
    },
    /**
     * @inheritDoc
     */
    needPreventLeave() {
      return this.hasMerging;
    },
  },
  created() {
    this.fetchFilters();
  },
  data() {
    return {
      /**
       * @description Столбцы поиска дублей.
       * @type {(string[])}
       */
      duplicationColumns: [],
      /**
       * @description Заголовок неудачи поиска дублей.
       * @type {string}
       */
      duplicationFailTitle: '',
      /**
       * @description Строки поиска дублей.
       * @type {(object[])}
       */
      duplicationRows: [],
      /**
       * @description Загружаются дубли.
       * @type {boolean}
       */
      isDuplicationFetching: false,
      /**
       * @description Столбцы объединения.
       * @type {(string[])}
       */
      mergingColumns: [],
      /**
       * @description Строки объединения.
       * @type {(object[])}
       */
      mergingRows: [],
      /**
       * @description Пациент поиска дубликатов.
       * @type {(Object|null)}
       */
      patient: null,
      /**
       * @description Опции фильтрации по пациенту.
       * @type {object[]}
       */
      patientOptions: [],
      /**
       * @description Выбранные пациенты для объединения.
       * @type {(string[])}
       */
      selectedPatients: [],
      /**
       * @description Запрос поиска пациента.
       * @type {string}
       */
      patientSearchQuery: '',
    };
  },
  mergingDescriptions: [
    'Чтобы объединить карты, укажите главную карту, куда запишем все данные. Остальные карты после слияния будут удалены',
    'Укажите, из какой карты сохранить данные для разделов Основное, Анамнез и Анкета здоровья',
    'Данные из разделов: визиты, планы лечения, история посещений, снимки, счета будут объединены в Главной карте',
  ],
  methods: {
    onInputSearch: debounce(function _() {
      if (this.patient === null) {
        this.fetchFilters(this.patientSearchQuery);
      }
    }, 300),
    /**
     * @description Загрузить объединение карт.
     * @returns {void}
     */
    fetchDuplicationMerging() {
      this
        .$patientGateway
        .viewMedcardDuplicationMerging(this.selectedPatients)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ columns, rows }) => {
            this.mergingColumns = columns;
            this.mergingRows = rows;
          });
        });
    },
    /**
     * @description Загрузить фильтры поиска дублей.
     * @param {string} search
     * @returns {void}
     */
    fetchFilters(search = '') {
      this
        .$patientGateway
        .viewMedcardDuplicationFilters(search)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ patients }) => { this.patientOptions = patients; });
        });
    },
    /**
     * @description Обработать ввод пациента для объединения.
     * @param {string}  patientId Идентификатор пациента.
     * @param {boolean} isChecked Выбран.
     * @returns {void}
     */
    onDuplicationPatientInput(patientId, isChecked) {
      this.selectedPatients = [
        ...(isChecked ? [patientId] : []),
        ...this.selectedPatients.flatMap((value) => (patientId !== value ? [value] : [])),
      ];
    },
    /**
     * @description Обработать отправку дублей.
     * @returns {void}
     */
    onDuplicationSubmit() {
      if (this.hasNotEnoughSelectedPatients) {
        this.notifyFail('Для объединения выберите более одного пациента');
      }
      this.fetchDuplicationMerging();
    },
    /**
     * @description Обработать отмену объединения.
     * @returns {void}
     */
    onMergingCancel() {
      this.mergingColumns = [];
      this.mergingRows = [];
    },
    /**
     * @description Обработать отправку объединения.
     * @type {Event} event Событие.
     * @returns {void}
     */
    onMergingSubmit(event) {
      this
        .$patientGateway
        .mergeMedcardDuplications({
          patient_ids: this.mergingRows.map(({ value }) => value),
          ...this.collectNamedFieldsByElement(event.target),
        })
        .then((result) => {
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
          result.forEach(({ patient_id: id, title }) => {
            this.mergingRows = [];
            this.$router.push({
              name: 'ClinicPanelPatientBasic',
              params: { id },
            });
            this.notifySuccess(title);
          });
        });
    },
    /**
     * @description Обработать изменение пациента.
     * @returns {void}
     */
    onInputPatient() {
      this.duplicationFailTitle = '';
    },
    /**
     * @description Обработать отправку поиска.
     * @returns {void}
     */
    onSearchSubmit() {
      if (this.patient === null) {
        this.notifyFail('Выберите пациента, чтобы найти дубли');
        return;
      }
      this.duplicationColumns = [];
      this.duplicationRows = [];
      this.isDuplicationFetching = true;
      this.selectedPatients = [];
      this
        .$patientGateway
        .searchMedcardDuplicationsForPatient(this.patient)
        .then((result) => {
          result.forEachLeft(({ title }) => { this.duplicationFailTitle = title; });
          result.forEach(({ columns, rows }) => {
            this.duplicationColumns = columns;
            this.duplicationRows = rows;
          });
        })
        .finally(() => { this.isDuplicationFetching = false; });
    },
  },
  mixins: [
    formMixin,
    notifierMixin,
    preventLeaveWithoutConfirmMixin,
  ],
  name: 'ClinicPanelMedcardMerging',
};
</script>
<style scoped lang="scss">
@use "@/scss/buttons";

.medcard-duplications,
.medcard-merging-cards {
  width: 100%;
  min-width: 1300px;
  border-collapse: collapse;
  font-size: .875rem;
  line-height: 1rem;
  overflow: auto;
  table-layout: fixed;
  &__body-cell {
    padding: 15px 8px;
    text-align: left;
    text-transform: none;
    white-space: nowrap;
    &.body-cell-link {
      display: flex;
      align-items: center;
      white-space: normal;
      a {
        font-size: .955rem;
        color: inherit;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
  &__body-line {
    border-bottom: 1px solid var(--fill-color);
  }
  &__body-line:hover {
    background: var(--fill-color);
  }
  &__head-cell {
    padding: 10px 8px;
    text-align: left;
  }
  &__head-line {
    border-bottom: 2px solid var(--action-color);
    font-weight: 700;
  }
}

.medcard-merging {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  padding: 2rem 1rem;
  &__form {
    display: grid;
    gap: 40px;
    overflow: auto;
  }
  &__wrapper-description {
    display: flex;
    gap: 22px;
    margin-bottom: 20px;
  }
  &__description {
    display: grid;
    grid-template-rows: auto 1fr;
    row-gap: 7px;
    margin-bottom: 0 !important;
    padding: .5rem;
    width: min(100%, 22rem);
    border-radius: 10px;
    border: 1px solid var(--action-color);
    counter-increment: descriptionCounter;
    &::before {
      content: counter(descriptionCounter);
      display: block;
      text-align: center;
    }
  }
  &__wrapper-table {
    overflow-x: auto;
  }
  &__wrapper-button {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  &__cancel {
    @include buttons.btn-transparent(10rem, 3rem, 1rem);
    min-height: 3rem;
  }
  &__submit {
    @include buttons.btn-blue(10rem, 3rem, 1rem);
    min-height: 3rem;
  }
  &__submit:disabled {
    background-color: var(--unfocus-color);
  }
  &__cancel,
  &__submit {
    display: inline-flex;
  }
}

.medcard-merging-leave {
  &__button-wrapper {
    display: flex;
    gap: 10px;
    padding: 8px;
  }
  &__no {
    @include buttons.btn-transparent(8rem, 2.5rem, 1rem);
  }
  &__yes {
    @include buttons.btn-blue(6rem, 2.5rem, 1rem);
  }
  &__no,
  &__yes {
    display: inline-block;
    width: 100%;
  }
}

.medcard-merging-option {
  font-size: 0;
}

.medcard-merging-search {
  display: flex;
  flex-direction: row;
  gap: 2rem 3rem;
  &__input {
    width: min(100%, 428px);
  }
  &__submit {
    @include buttons.btn-blue(10rem, 3rem, 1rem);
    flex-shrink: 0;
    padding: 14px 30px;
  }
}

@media screen and (max-width: 1330px) {
  .medcard-duplications {
    &__head-line {
      th:nth-child(2) {
        width: 200px;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .medcard-merging {
    &__wrapper-description {
      flex-direction: column;
    }
    &__description {
      width: 100%;
    }
  }
}

@media screen and (max-width: 480px) {
  .medcard-merging  {
    &__wrapper-button {
      flex-wrap: wrap;
      button {
        width: 100%;
      }
    }
  }
  .medcard-merging-search {
    flex-direction: column;
  }
  .medcard-merging-leave {
    .v-card {
      &__text {
        flex-wrap: wrap;
      }
    }
  }
}

@media screen and (max-width: 420px) {
  .medcard-merging-leave {
    &__button-wrapper {
      flex-direction: column;
    }
  }
}
</style>
